import React, {useState} from 'react';

// components
import {OneTimePasswordForm, UsernameForm} from './components';
import {Footer, LanguageSelector} from '../../shared/components';

// services
import {ConfigManager} from '../../shared/services/ConfigManager';

// styles
import {
  FormContainer,
  Wrapper,
  Header,
  Logo,
  LanguageSelectorWrapper,
  LogoWrapper,
  FormContainerContent,
  LanguageSelectorWrapperWithLogo,
} from './LoginPage-styles';

const LoginPage = () => {
  const portalConfig = ConfigManager.getConfig();
  const [username, setUsername] = useState('');
  const [isLanguageButtonDisabled, setIsLanguageButtonDisabled] =
    useState(true);

  /**
   * Handle submit and set username
   */
  const handleSubmit = (name: string) => {
    setUsername(name);
  };

  /**
   * Handle return and set username to empty to show username form
   */
  const handleReturn = () => {
    setUsername('');
  };

  /**
   * Handle login and navigate to the home page
   * Use window.location.href to navigate to home page and
   * for a full page reload since the token is stored in memory.
   * This ensures the app initializes properly and re-triggers
   * useEffect hooks to fetch the user config.
   */
  const handleLogin = () => {
    window.location.href = '/';
  };

  /**
   * Handle pending change for language button
   * @param isPending
   */
  const handleOnPending = (isPending: boolean) => {
    setIsLanguageButtonDisabled(isPending);
  };

  return (
    <Wrapper>
      <FormContainer>
        <FormContainerContent>
          <Header>
            {portalConfig?.logo ? (
              <LogoWrapper>
                <LanguageSelectorWrapperWithLogo>
                  <LanguageSelector disabled={isLanguageButtonDisabled} />
                </LanguageSelectorWrapperWithLogo>
                <Logo url={portalConfig?.logo} />
              </LogoWrapper>
            ) : (
              <LanguageSelectorWrapper>
                <LanguageSelector disabled={isLanguageButtonDisabled} />
              </LanguageSelectorWrapper>
            )}
          </Header>
          {!username ? (
            <UsernameForm
              onSubmit={handleSubmit}
              handleOnPending={handleOnPending}
            />
          ) : (
            <OneTimePasswordForm
              username={username}
              onSubmit={handleLogin}
              onReturn={handleReturn}
              handleOnPending={handleOnPending}
            />
          )}
        </FormContainerContent>
        <Footer />
      </FormContainer>
    </Wrapper>
  );
};

export default LoginPage;
